import { isNullOrUndefined, onReady } from '/Assets/js/common/utilities.js';

export default class Triggers {
  init() {
    onReady(() => {
      const isOptInConfirmed = window.location.href.includes('email-communications/opt-in-confirmed_TY');

      if (!isOptInConfirmed) {
        return;
      }

      // Check url for D365 contact id
      const searchParams = new URLSearchParams(window.location.search);
      const contactId = searchParams.has('contactid') ? searchParams.get('contactid') : '';

      if (isNullOrUndefined(contactId)) {
        return;
      }

      // Activate DOI trigger in D365
      fetch('/CustomerInsightsJourneys/TriggerOptInConfirm', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: 'contactid=' + contactId,
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
        })
        .catch(function () {
          //console.error(e);
        });
    });
  }
}
